module.exports = __webpack_public_path__ + "res/img_back.44bfc5740226e55dc24bb939c590a896.png";